import { Alert, Link } from "@mui/material";
import React from "react";
import { CONTACT_US_URL } from "@/configs/constants";
import { getHrefRel, getHrefTarget } from "@/utils/externalLink";

export const ContactUsAlert: React.FC = () => {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      解析結果について、お気づきの点やご要望がございましたら、
      <Link
        href={CONTACT_US_URL}
        target={getHrefTarget(CONTACT_US_URL)}
        rel={getHrefRel(CONTACT_US_URL)}
        sx={{ fontWeight: "bold" }}
      >
        お問い合わせフォーム
      </Link>
      よりご連絡ください
    </Alert>
  );
};
